// import search from './../component/search.vue'
export default {
  className: 'facility',
  fields: [
    {
      // 绑定用户
      name: 'user',
      listWhere: (where) => {
        where.status = 'ordinary'
      }
    },
    {
      // 版本号
      name: 'version'
    },
    {
      // 设备序列号
      name: 'serialNumber'
    }
  ],
  search: [
    'user.isInland',
    'user',
    'serialNumber'
  ],
  action: {
    edit: false,
    create: false,
    export: false,
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '你确定要删除这条记录吗?')
        console.log(record, vm, modelName)
        let rs = await vm.$tkParse.post(`/facility/relieve`, {
          objectId: record.objectId
        }).catch(() => {
          vm.$notification['error']({
            message: '网络错误',
            description: '删除数据失败'
          })
        })
        if (rs.data.code === 1) {
          vm.$notification['success']({
            message: '操作成功',
            description: '记录已被删除'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
        } else {
          vm.$notification['error']({
            message: '操作失败',
            description: rs.data.message
          })
          vm.refresh()
        }
      }
    }
  }
}
